
<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <p class="w-full mt-4"> Production Date
        <datepicker :inline="false" v-model="dataDate"></datepicker>
        </p>
      </div>
      <div class="vx-col md:w-1/2 w-full">
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
         <vs-button class="ml-8" color="success" @click="save_changes(false)" :disabled="!validateForm">Next Step</vs-button>
        </div>
        <br/>
      </div>
    </div>
  </div>
</template>

<script>
import moduleOperationList from '@/store/operation/moduleOperationList.js'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import axios from '@/axios.js'
import moment from 'moment'

export default {
  components: {
    vSelect,
    Datepicker
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isMounted: false,
      // Data Sidebar
      buttonSubmitOpen: false,
      state:{},
      dataDate: '',
      dataOperationCategory:'3',
      dataIdPeople: '',
      data_option_people_name: [],
      maxdateoperation : ''
    }
    
  },
  computed: {
    validateForm () {
      return !this.errors.any() && (this.dataDate && this.dataOperationCategory)
    },
    currentPage () {
      if (this.isMounted) {
        if (this.data_local.id) return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      if (this.data_local.id) return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
    }
  },
  methods: {
    getMaxInventoryDate()
    {
        var dateStop = moment(this.dataDate).add(12, 'hours').format('YYYY-MM-DD')
        axios.get('/getmaxinventorydate')
          .then((response) => {
            this.maxdateoperation = response.data
          })
    },
    save_changes () {
      this.$vs.loading()
      if (moment(this.maxdateoperation).add(12, 'hours') >= moment(this.dataDate))
      {
        this.$vs.notify({
          color: 'danger',
          title: 'Wrong Date!',
          text: 'You cannot add Production after an Inventory (Inventory date : '+this.maxdateoperation+')'
        })
        return
      }
      const obj = {
        date: moment(this.dataDate).add(12, 'hours').format('YYYY-MM-DD hh:mm:ss+02'),
        operationcategory: this.dataOperationCategory,
        isactive: true
      }
      {
        this.$store.dispatch('operationList/createOperation', obj)
        .then(response =>
          {
          this.$vs.loading.close() 
          this.$vs.notify({
            color: 'success',
            title: '',
            text: 'Operation Correctly Started!'
          })
          this.$router.push({path:'/production-edit/' + this.$store.state.operationList.operation.id})
          }
        )        
        .catch(err => { 
          this.$vs.loading.close() 
        this.$vs.notify({
          color: 'alert',
          title: 'An Error Occured!',
          text: 'The operation was NOT added, please contact your dev'
        }) })
      }
    }
  },
  mounted () {
    this.isMounted = true
  },
  created() {
    this.getMaxInventoryDate ()
    this.dataDate = moment().format("D MMM yyyy");
  }
}
</script>
 
